<h5 [class.dark]="dark" *ngIf="title">{{title}}</h5>
<p class="subtitle" *ngIf="subtitle">{{ subtitle }}</p>
<div class="input-field" [class.dropdown]="dropdown" [class.dropdownText]="!dropdownText" [class.focus]="focused"
    [class.disabled]="disabled" [class.dark]="dark" [tabindex]="disabled ? 0 : null" (focus)="onFocus()"
    (focusout)="onFocusOut()" (click)="dropdownOpen = !dropdownOpen">
    <div>
        <fa-icon *ngIf="dollarSign" class="dollar-icon" [icon]="faDollarSign" (click)="focusInput()"></fa-icon>
        <input [type]="isPassword ? 'password' : 'text'" [placeholder]="placeholder" (input)="onType($event)"
            [value]="inputValue" #input (focus)="onFocus()" [disabled]="disabled || !dropdownText"
            [readonly]="readonly">
        <fa-icon *ngIf="focused && dropdownText" [icon]="faTimes" (mouseup)="clearInput()"></fa-icon>
        <fa-icon *ngIf="dropdown" class="dropdown-icon" [icon]="dropdownOpen ? faSortUp : faSortDown"
            (click)="focusInput()"></fa-icon>
    </div>
    <fa-icon *ngIf="searchSign" #searchIcon class="search-icon" [class.dark]="dark" [icon]="faSearch"
        (click)="searchFunction()"></fa-icon>
</div>
<div class="input-state" [ngSwitch]="inputState">
    <p *ngSwitchCase="'success'">{{successMsg}}</p>
    <p *ngSwitchCase="'error'">{{errorMsg}}</p>
    <p *ngSwitchDefault>{{info}}</p>
</div>
<div class="dropdown-area" *ngIf="dropdown && dropdownOpen">
    <ng-content></ng-content>
</div>